import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './PersistLink.css';


export default class PersistLink extends React.Component {

  handleClick = () => {
    const { to, state, history, data, previousPageLevel2 } = this.props;
    if (previousPageLevel2 === true) {
      if (state) {
        window.sessionStorage.setItem("previousPageStateLevel2", JSON.stringify({ ...state, prevSavedStatePath: history.location.pathname }));
      } else {
        window.sessionStorage.removeItem("previousPageState");
      }
    } else {
      if (state) {
        window.sessionStorage.setItem("previousPageState", JSON.stringify({ ...state, prevSavedStatePath: history.location.pathname }));
      } else {
        window.sessionStorage.removeItem("previousPageState");
      }
    }
    if (typeof data === 'object') {
      window.sessionStorage.setItem("getCurrentDropDown", JSON.stringify({ ...data }));
      if (this.props.setCurrentDropDownSelect) {
        this.props.setCurrentDropDownSelect(JSON.stringify({ ...data }))
      }

    } else {
      window.sessionStorage.setItem("getCurrentDropDown", data);
    }
    if (data === undefined || data === '') {
      window.sessionStorage.removeItem("getCurrentDropDown");
      if (this.props.resetCurrentDropDownSelect) {
        this.props.resetCurrentDropDownSelect()
      }
    }

    history.push(to);
  }

  render() {
    return (
      <button className={classnames("persist-link", this.props.className, { 'is_disabled': this.props.isDisable })} onClick={this.handleClick} disabled={this.props.disabled}>{this.props.children}</button>
    )
  }
}

PersistLink.defaultProps = {
  isDisable: false
}

PersistLink.propTypes = {
  to: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  state: PropTypes.object,
  isDisable: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/common/PersistLink/PersistLink.js